import {VosLogo} from 'Shared/backend/icons/VosLogo';

export function LoginBanner()
{
	return (
		<header>
			<div class='headerOntoit'>
				<VosLogo />
			</div>
		</header> 
	);
}

